
import { defineComponent, ref, reactive, toRefs } from "vue";

export default defineComponent({
  props: ["title", "img", "radius", "text", "isText", "isLine"],
  setup(props) {
    return {
      ...toRefs(props),
    };
  },
});
